(() => {
  const root = document.documentElement;
  let queued = false;
  let observedPanel;
  const resizeObserver = new ResizeObserver(schedule);
  function updateChatPosition() {
    queued = false;
    const panel = document.getElementById('tinycookie-wrapper');
    if (panel !== observedPanel) {
      resizeObserver.disconnect();
      if (panel) resizeObserver.observe(panel);
      observedPanel = panel;
    }
    const button = document.getElementById('chatbase-bubble-button');
    if (!panel || !button) {
      root.removeAttribute('data-rf-cookie-overlap');
      root.style.removeProperty('--rf-chat-bottom');
      return;
    }
    const p = panel.getBoundingClientRect();
    const b = button.getBoundingClientRect();
    const normalTop = innerHeight - 16 - b.height;
    const overlap = p.width > 0 && p.height > 0 && p.top < innerHeight - 16 && p.bottom > normalTop && p.left < b.right && p.right > b.left;
    if (overlap && p.top >= b.height + 24) {
      root.style.setProperty('--rf-chat-bottom', `${Math.ceil(innerHeight - p.top + 12)}px`);
      root.setAttribute('data-rf-cookie-overlap', '');
    } else {
      root.removeAttribute('data-rf-cookie-overlap');
      root.style.removeProperty('--rf-chat-bottom');
    }
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(updateChatPosition);
  }
  new MutationObserver(schedule).observe(document.body, {childList: true});
  window.addEventListener('resize', schedule, {passive: true});
  schedule();
  document.addEventListener('click', event => {
    const link = event.target.closest('.product-mobile-purchase-link');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const form = document.getElementById(link.hash.slice(1));
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    form.setAttribute('tabindex', '-1');
    form.focus({preventScroll: true});
    const target = form.querySelector('.product-form__price-first') || form;
    target.scrollIntoView({block: 'start', behavior: 'auto'});
  }, true);
})();
